import * as React from 'react';
import { ArchetypeSpecificStepRunSummaryPanelProps } from '.';

export const TakeoffStepRunSummaryPanel: React.FC<ArchetypeSpecificStepRunSummaryPanelProps> = ({ stepRun }) => {
    return <div>Takeoff Step Run Summary Panel - {stepRun.displayName || stepRun.stepId}</div>;
};
